import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const TERMS = [
  {
    title: "1. Agreement to Terms",
    body: (
      <>
        By accessing knightmediagroup.com or engaging Knight Media Group
        (&ldquo;KMG&rdquo;) for services, you agree to be bound by these Terms
        &amp; Conditions. If you do not agree, please discontinue use of our
        site and services.
      </>
    ),
  },
  {
    title: "2. Services",
    body: "KMG provides social media management, content creation, brand strategy, logo and website design, event photography, reputation management, analytics, and related services. Scope, deliverables, and timelines for each engagement are governed by a separate statement of work or proposal.",
  },
  {
    title: "3. Payment Terms",
    body: "Invoices are due per the schedule outlined in your engagement agreement. Late payments may incur fees and pause active work. Deposits are non-refundable once creative work has begun.",
  },
  {
    title: "4. Intellectual Property",
    body: "Final deliverables become the client’s property upon full payment, unless otherwise noted. KMG retains the right to display completed work in our portfolio and case studies, with reasonable attribution.",
  },
  {
    title: "5. Confidentiality",
    body: "Both parties agree to keep proprietary information shared during an engagement confidential and to use it only for the purposes of performing the engagement.",
  },
  {
    title: "6. Limitation of Liability",
    body: "KMG’s total liability for any claim arising from our services shall not exceed the fees paid to us during the three (3) months preceding the event giving rise to the claim.",
  },
  {
    title: "7. Governing Law",
    body: "These Terms are governed by the laws of the State of Ohio, without regard to its conflict-of-laws principles. Any dispute will be resolved in the state or federal courts located in Hamilton County, Ohio.",
  },
  {
    title: "8. Changes to Terms",
    body: "We may update these Terms periodically. Continued use of our site or services after changes constitutes acceptance of the revised Terms.",
  },
  {
    title: "9. Contact",
    body: (
      <>
        Questions? Reach us at{" "}
        <a href="mailto:damon.knight@knightmediagroup.com" className="text-[#5b80ff] hover:underline">
          damon.knight@knightmediagroup.com
        </a>{" "}
        or 1(513)840-4087.
      </>
    ),
  },
];

export default function TermsConditions() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#5b80ff] hover:text-white transition mb-10"
          data-testid="back-home-link"
        >
          <ArrowLeft size={16} /> Back to home
        </Link>
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#1440E1] font-semibold mb-4">
          Legal
        </p>
        <h1
          className="text-white leading-[1.05] tracking-tight mb-8 font-extrabold"
          style={{ fontFamily: '"Arial Black", Arial, sans-serif', fontSize: "clamp(38px, 5vw, 60px)" }}
          data-testid="terms-heading"
        >
          Terms &amp; Conditions
        </h1>
        <p className="text-white/55 text-sm mb-12">Last updated: February 2026</p>

        <div className="space-y-8 text-white/80 leading-relaxed">
          {TERMS.map((t) => (
            <Section key={t.title} title={t.title}>
              {t.body}
            </Section>
          ))}
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2
        className="text-white text-xl sm:text-2xl mb-3"
        style={{ fontFamily: '"Arial Black", Arial, sans-serif' }}
      >
        {title}
      </h2>
      <p className="text-white/75 text-base">{children}</p>
    </section>
  );
}
